import React, { useState, useEffect } from 'react';
import styles from './EntranceExam.module.css';
// import { fetchassessments } from '../../../../../ReduxSlice/AssessmentSlice';
import { fetchassessments } from '../../../../ReduxSlice/AssessmentSlice';
import { useAuth } from '../../../../Service/AuthService';
import { useDispatch, useSelector } from 'react-redux';

export default function EntranceExamQuestions() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const dispatch = useDispatch();

  const {
    assessments,
    school_id,
    pageSize,
    activePage,
  } = useSelector((state) => state.assessments);

  const { token } = useAuth();

  useEffect(() => {
    dispatch(fetchassessments({
      page: activePage,
      page_size: pageSize,
      school_id: school_id,
      token: token,
    }));
  }, [token]);

  const questions = assessments[0]?.questions || [];
  const totalQuestions = questions.length;

  const handleAnswer = (questionId, answer) => {
    setUserAnswers((prev) => ({ ...prev, [questionId]: answer }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
    } else {
      setShowResults(true);
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
    }
  };

  const calculateScore = () => {
    const correctAnswers = [
      { id: 1, answer: 'c' },
      { id: 2, answer: 'b' },
      { id: 3, answer: 'b' },
      { id: 4, answer: 'b' },
      { id: 5, answer: 'a' },
    ];

    const score = correctAnswers.reduce((acc, curr) => {
      return userAnswers[curr.id] === curr.answer ? acc + 1 : acc;
    }, 0);

    return (score / totalQuestions) * 100;
  };

  const ProgressBar = ({ current, total }) => {
    const progress = (current / total) * 100;
    return (
      <div className={styles.progressBarContainer}>
        <div
          className={styles.progressBarFill}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    );
  };

  const Question = ({ question, onAnswer, userAnswer }) => {
    return (
      <div className={styles.questionContainer}>
        <h2 className={styles.questionText}>{question?.text}</h2>
        <div className={styles.optionsContainer}>
          {question?.options &&
            Object.entries(question?.options).map(([key, value]) => (
              <button
                key={key}
                onClick={() => onAnswer(question.id, key)}
                className={`${styles.optionButton} ${userAnswer === key ? styles.selected : ''
                  }`}
              >
                {key.toUpperCase()}. {value}
              </button>
            ))}
        </div>
      </div>
    );
  };

  const ResultsPopup = ({ score, onClose }) => {
    const isPassed = score >= 60;
    const correctAnswers = Math.round((score / 100) * totalQuestions);

    return (
      <div className={styles.overlay}>
        <div className={styles.popup}>
          <h2 className={styles.resultTitle}>Exam Results</h2>
          <div className={styles.scoreCircle}>
            <span className={styles.scorePercentage}>{score.toFixed(0)}%</span>
          </div>
          <p className={styles.scoreText}>
            You answered {correctAnswers} out of {totalQuestions} questions correctly.
          </p>
          <p
            className={`${styles.resultText} ${isPassed ? styles.passed : styles.failed
              }`}
          >
            {isPassed
              ? 'Congratulations! You passed!'
              : 'Sorry, you did not pass.'}
          </p>
          <button onClick={onClose} className={styles.closeButton}>
            Close
          </button>
        </div>
      </div>
    );
  };

  const currentQuestion = questions[currentQuestionIndex];
  const currentAnswer = userAnswers[currentQuestion?.id];

  return (
    <div className={styles.examContainer}>
      {totalQuestions > 0 ? (
        <>
          <ProgressBar current={currentQuestionIndex + 1} total={totalQuestions} />
          <p className={styles.questionCounter}>
            Question {currentQuestionIndex + 1} of {totalQuestions}
          </p>
          <Question
            question={currentQuestion}
            onAnswer={handleAnswer}
            userAnswer={currentAnswer}
          />
          <div className={styles.navigationButtons}>
            <button
              onClick={handlePrevious}
              disabled={currentQuestionIndex === 0}
              className={styles.navButton}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={!currentAnswer} // Ensures the user must answer before proceeding
              className={styles.navButton}
            >
              {currentQuestionIndex === totalQuestions - 1 ? 'Finish' : 'Next'}
            </button>
          </div>
        </>
      ) : (
        <p>Loading questions...</p>
      )}
      {showResults && (
        <ResultsPopup
          score={calculateScore()}
          onClose={() => setShowResults(false)}
        />
      )}
    </div>
  );
}
